import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {SearchDataSource} from "../models/search.data-source";
import {SearchResponseApiModel} from "../models/search-response-api-model";
import {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";
import {CompetitionApiModel} from "../../common/competition/models/competition-api-model";
import {CompetitorDomainModel} from "../../common/competitor/models/competitor-domain-model";
import {CompetitorApiModel} from "../../common/competitor/models/competitor-api-model";
import {SportDomainModel} from "../../sports/models/sport-domain-model";
import {CountryDomainModel} from "../../common/country/models/country-domain-model";
import {AthleteDomainModel} from "../../common/athlete/athlete-domain-model";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {CompetitorFactory} from "../../common/competitor/domain-services/competitor-factory";
import {AthleteApiModel} from "../../common/athlete/athlete-api-model";
import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";

export class SearchFactory extends BaseFactory {

  static injectables = [...BaseFactory.injectables, CompetitorFactory];

  constructor(loggerUtils: LoggerUtils, termsUtils: TermsUtils, competitorFactory: CompetitorFactory) {
    super(loggerUtils, termsUtils);

    this.competitorFactory = competitorFactory;
  }


  createResponse(apiModel, request: BaseApiRequestParams){
    return new SearchResponseApiModel(apiModel, request);
  }

  createDomainModel(apiModel: SearchResponseApiModel): SearchDataSource {
    const sportsMap: Map<Number, SportDomainModel> = this.createDomainMap(apiModel.sports, SportDomainModel);
    const countriesMap: Map<Number, CountryDomainModel> = this.createDomainMap(apiModel.countries, CountryDomainModel);

    const competitions: Array<CompetitionDomainModel> = this.createCompetitionsDomain(apiModel, sportsMap, countriesMap);
    const competitors: Array<CompetitorDomainModel> = this.createCompetitorsDomain(apiModel, sportsMap, countriesMap);
    const athletes: Array<AthleteDomainModel> = this.createAthletesDomain(apiModel, sportsMap, countriesMap, null);

    const dataSource: SearchDataSource = new SearchDataSource(apiModel, competitions, competitors, athletes, true);

    return dataSource;
  }

  createCompetitionsDomain(apiModel: SearchResponseApiModel, sportsMap: Map<Number, SportDomainModel>, countriesMap: Map<Number, CountryDomainModel>): Array<CompetitionDomainModel> {
    const competitionsDomainModel: Array<CompetitionDomainModel> = (apiModel.competitions || []).map((competition: CompetitionApiModel) => {
      const sportDomainModel: SportDomainModel = sportsMap.get(competition.sportId);
      const countryDomainModel: CountryDomainModel = countriesMap.get(competition.countryId);

      return new CompetitionDomainModel(competition, countryDomainModel, sportDomainModel)
    });

    return competitionsDomainModel;
  }

  createCompetitorsDomain(apiModel: SearchResponseApiModel, sportsMap: Map<Number, SportDomainModel>, countriesMap: Map<Number, CountryDomainModel>): Array<CompetitionDomainModel> {
    const competitorsDomainModel: Array<CompetitorDomainModel> = (apiModel.competitors || []).map((competitor: CompetitorApiModel) => {
      const sportDomainModel: SportDomainModel = sportsMap.get(competitor.sportId);
      const countryDomainModel: CountryDomainModel = countriesMap.get(competitor.countryId);

      return new CompetitorDomainModel(competitor, countryDomainModel, sportDomainModel)
    });

    return competitorsDomainModel;
  }

  createAthletesDomain(apiModel: SearchResponseApiModel, sportsMap: Map<Number, SportDomainModel>, countriesMap: Map<Number, CountryDomainModel>, competitorsMap: Map<Number, CompetitorDomainModel>): Array<AthleteDomainModel> {
    const athletesDomainModel: Array<CompetitorDomainModel> = (apiModel.athletes || []).map((athlete: AthleteApiModel) => {
      const sportDomainModel: SportDomainModel = sportsMap.get(athlete.sportId);
      const countryDomainModel: CountryDomainModel = countriesMap.get(athlete.nationalityId);
      return new AthleteDomainModel(athlete, countryDomainModel, null, sportDomainModel)
    });

    return athletesDomainModel;
  }
}
